<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">器材名称：</span>
        <el-input v-model="fireequipmentName" clearable placeholder="请输入器材名称"></el-input>
      </div>
      <div class="header_item">
        <el-button v-if="showButton('search')" icon="el-icon-search" @click="searchFireequipmentList(true)">查询</el-button>
        <el-button class="search_btn" v-if="showButton('insert')" icon="el-icon-plus" @click="propInsert()">新增</el-button>
        <el-button v-if="showButton('export')" icon="el-icon-upload2" @click="propExcel()">导出Excel</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        ref="table"
        v-loading="loading"
        :data="fireequipmentList"
        height="100%">
        <el-table-column label="序号" width="60" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="goodName" label="器材名称" width="180" align="center"></el-table-column>
        <el-table-column prop="goodType" label="规格" align="center"></el-table-column>
        <el-table-column prop="useWay" label="用途" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column prop="goodPosition" label="位置" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="propUpdate(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="exportViewCode(row)">导出二维码</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增器材 修改器材信息 -->
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增器材' : '修改器材信息'"
      :visible.sync="asyncFireequipment"
      width="35%">
      <el-form ref="form" :model="formFireequipment" :rules="rulesFireequipment" label-width="auto" class="rule_form">
        <el-form-item label="器材名称：" prop="goodName">
          <el-input v-model="formFireequipment.goodName" clearable placeholder="请输入器材名称"></el-input>
        </el-form-item>
        <el-form-item label="器材规格：" prop="goodType">
          <el-input v-model="formFireequipment.goodType" clearable placeholder="请输入器材规格"></el-input>
        </el-form-item>
        <el-form-item label="器材用途：" prop="useWay">
          <el-input v-model="formFireequipment.useWay" clearable placeholder="请输入器材用途"></el-input>
        </el-form-item>
        <el-form-item label="器材位置：" prop="goodPosition">
          <el-input v-model="formFireequipment.goodPosition" clearable placeholder="请输入器材位置"></el-input>
        </el-form-item>
        <el-form-item label="器材照片：" prop="fileList">
          <upload-image :file-list="formFireequipment.fileList" @delectImage="delectImage" :disabled="false">
            <template #info>
                <span>支持jpg、png、gif格式文件</span>
            </template>
          </upload-image>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncFireequipment = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsertForm() : submitUpdateForm()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia';
import UploadImage from '@/components/uploadImage';
import { downFiles, throttle } from '../../plugins/public';
  export default {
    components: {
      UploadImage
    },
    data() {
      return {
        fireequipmentName: '',
        timeDate: '',
        pageNum: 1,
        pageSize: 10,
        total: 0,
        loading: false,
        fireequipmentList: [],
        asyncTitle: true, // true 新增 false  修改
        asyncFireequipment: false, // 弹窗
        formFireequipment: {}, // 表单信息
        rulesFireequipment: {
          goodName: [{
            required: true,
            message: '请输入器材名称',
            trigger: 'blur'
          }],
          goodType: [{
            required: true,
            message: '请输入器材规格',
            trigger: 'blur'
          }],
          useWay: [{
            required: true,
            message: '请输入器材用途',
            trigger: 'blur'
          }],
          goodPosition: [{
            required: true,
            message: '请输入器材位置',
            trigger: 'blur'
          }],
          fileList: [{
            required: true,
            message: '请上传器材照片',
            trigger: ['blur', 'change']
          }]
        }, // 表单校验规则
        loadingView: ''
      }
    },
    mounted() {
      this.searchFireequipmentList(true);
    },
    methods: {
      // 查询消防器材信息
      searchFireequipmentList(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        this.loading = true;
        this.fireequipmentList = [];
        this.$api.Safety.searchFireequipmentList({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          goodName: this.fireequipmentName
        }).then((res) => {
          if(res.success) {
            this.total = res.data.total;
            this.fireequipmentList = res.data.list;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      // 导出
      propExcel() {
        this.functionLoading();
        this.$api.Safety.exportFireequipmentfile({
            goodName: this.fireequipmentName
        }).then((res) => {
            if(res) {
              downFiles(res, '消防器材', 'xls');
            }
            this.loadingView.close();
        }).catch(() => {
          this.loadingView.close();
        })
      },
      functionLoading() {
        this.loadingView = this.$loading({
          lock: true,
          text: '请稍后...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      },
      // 打开添加信息
      propInsert() {
        this.asyncTitle = true;
        this.asyncFireequipment = true;
      },
      // 打开修改信息
      propUpdate(row) {
        this.$api.Safety.getFireequipmentImageInfo({
          id: row.id
        }).then((res) => {
          if(res.success) {
            this.$set(this.formFireequipment, 'fileList', res.data.map(item => {
              return {
                id: item.id,
                url:`https://htpipe.thhy-tj.com/${item.file}`,
                name: item.file,
                nameImg:item.fileName
              }
            }));
          }
        })
        this.$set(this.formFireequipment, 'id', row.id);
        this.$set(this.formFireequipment, 'goodName', row.goodName);
        this.$set(this.formFireequipment, 'goodType', row.goodType);
        this.$set(this.formFireequipment, 'useWay', row.useWay);
        this.$set(this.formFireequipment, 'goodPosition', row.goodPosition);
        this.asyncTitle = false;
        this.asyncFireequipment = true;
      },
      // 删除公告信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该器材信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Safety.deleteFireequipmentInfo({
          id: row.id
        }).then(res => {
          if(res.success) {
            this.searchFireequipmentList(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 导出二维码
      exportViewCode(row) {
        this.$api.System.GETEXPORTTOKENDATA({
          id: row.id,
        }).then((res) => {
          if(res.success) {
            this.$api.Safety.getFireequipmentCode({
              authcode: res.data
            }).then((res) => {
              downFiles(res, row.goodName,'png')
            })
          }
        })
      },
      // 提交添加信息
      submitInsertForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formFireequipment);
            params.fileList = params.fileList.map(item => {
              return {
                file: item.name
              }
            });
            this.$api.Safety.insertFireequipmentInfo(params).then((res) => {
              if(res.success) {
                this.asyncFireequipment = false;
                this.$message.success('添加成功！');
                this.searchFireequipmentList(true);
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改信息
      submitUpdateForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formFireequipment);
            params.fileList = params.fileList.map(item => {
              return {
                file: item.name
              }
            });
            this.$api.Safety.insertFireequipmentInfo(params).then((res) => {
              if(res.success) {
                this.asyncFireequipment = false;
                this.$message.success('修改成功！');
                this.searchFireequipmentList(true);
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      //删除上传图片
      delectImage(item){
        let uploadId = item.id
        this.formFireequipment.fileList.splice(this.formFireequipment.fileList.findIndex(itm => itm.id === uploadId),1)
        this.$message.success("删除成功!")
      },
      // 切换页码
      changePageNum(page) {
        this.pageNum = page;
        this.searchFireequipmentList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchFireequipmentList();
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      }
    },
    watch: {
      asyncFireequipment(bol) {
        if(!bol) {
          this.formFireequipment = {};
          this.$refs.form.resetFields();
        } else {
          this.$set(this.formFireequipment, 'fileList', []);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '@/style/layout-main.scss';
</style>